import { Schema } from 'rsuite'

export const BatchCreateStorageContainerValidationModel = Schema.Model({
  count: Schema.Types.NumberType()
    .isRequired('Количество контейнеров обязательно')
    .min(1, 'Минимум 1 контейнер')
    .max(100, 'Максимум 100 контейнеров'),
  
  size: Schema.Types.StringType()
    .isRequired('Выберите размер'),
  
  type: Schema.Types.StringType()
    .isRequired('Выберите тип'),
  
  prefix: Schema.Types.StringType()
    .maxLength(10, 'Префикс должен быть не более 10 символов'),
  
  description: Schema.Types.StringType()
    .maxLength(500, 'Описание должно содержать максимум 500 символов'),
  
  sanitization_interval_days: Schema.Types.NumberType()
    .min(1, 'Интервал должен быть не менее 1 дня')
})
